module.exports = __webpack_public_path__ + "media/Video_Fresher.ddb33129.mp4";